import * as React from "react";

import { JoinDrawer } from "../Common";

import { useReactWishlistGuestInitialState } from "./providers";

import { AppLoading } from "./app-loading";

export const Page: React.FunctionComponent = () => {
  return (
    <div className="bbnt-react-wishlist-guest-page">
      <AppLoading />

      <JoinDrawer useInitialState={useReactWishlistGuestInitialState} allowJoining/>
    </div>
  );
};
